import { render } from "./UserBulkDialogue.vue?vue&type=template&id=119c8382&ts=true"
import script from "./UserBulkDialogue.vue?vue&type=script&lang=ts"
export * from "./UserBulkDialogue.vue?vue&type=script&lang=ts"

import "./UserBulkDialogue.vue?vue&type=style&index=0&id=119c8382&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__